import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/consumers',
    redirectUri: window.location.origin,
  },
  cache: {
    // localStorage (rather than sessionStorage) persists the cached account and
    // tokens across tab/browser close, so the login session is maintained when
    // the tab is momentarily closed and reopened.
    cacheLocation: 'localStorage',
    // Safari/iOS drops sessionStorage across the cross-origin redirect to
    // Microsoft and back, which breaks handleRedirectPromise() (blank screen).
    // Persisting the transient auth state in a cookie survives the round-trip.
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: [process.env.REACT_APP_AZURE_API_SCOPE],
};

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
  console.log('[MSAL]', event.eventType, event.payload ?? event.error ?? '');
});
